import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'

const CATEGORY_MODEL_CLASS_NAME = 'Category'

const CATEGORY_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  TITLE: 'title',
  DESCRIPTION: 'description',
  TAGS: 'tags',
  IMG: 'img',
  SHARE_IMG: 'shareImg',
  NAME: 'name',
  SECTION: 'section',
  SECTION_ID: 'sectionId',
  PUBLISHED_AT: 'publishedAt',
  CONTENT_TITLE: 'contentTitle'
}

const CATEGORY_MODEL_KEY_POINTER = CATEGORY_MODEL_KEY.NAME
const CATEGORY_MODEL_VALIDATOR = {
  [CATEGORY_MODEL_KEY.TITLE]: [
    5,
    60
  ],
  [CATEGORY_MODEL_KEY.DESCRIPTION]: [
    20,
    160
  ],
  [CATEGORY_MODEL_KEY.TAGS]: [
    0,
    3
  ],
  [CATEGORY_MODEL_KEY.CONTENT_TITLE]: [
    10,
    60
  ],
  [CATEGORY_MODEL_KEY.NAME]: [
    3,
    20
  ]
}

const CATEGORY_MODEL_PLACEHOLDER = {
  [CATEGORY_MODEL_KEY.TITLE]: 'The Category Title',
  [CATEGORY_MODEL_KEY.DESCRIPTION]: 'This article will help you understand how to become happy.',
  [CATEGORY_MODEL_KEY.TAGS]: 'Category, Happiness, Joy',
  [CATEGORY_MODEL_KEY.IMG]: 'https//cdn.gymaholic.co/category/fitness.jpg',
  [CATEGORY_MODEL_KEY.SHARE_IMG]: 'https//cdn.gymaholic.co/category/fitness-share.jpg',
  [CATEGORY_MODEL_KEY.SECTION_ID]: '1',
  [CATEGORY_MODEL_KEY.NAME]: 'Fitness',
  [CATEGORY_MODEL_KEY.CONTENT_TITLE]: 'Fitness Made Simple',
  [CATEGORY_MODEL_KEY.PUBLISHED_AT]: false
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const CATEGORY_MODEL_ASSOCIATION = {
  [CATEGORY_MODEL_KEY.SECTION]: 'Section',
  [CATEGORY_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME
}

export {
  CATEGORY_MODEL_CLASS_NAME,
  CATEGORY_MODEL_KEY,
  CATEGORY_MODEL_KEY_POINTER,
  CATEGORY_MODEL_PLACEHOLDER,
  CATEGORY_MODEL_VALIDATOR,
  CATEGORY_MODEL_ASSOCIATION
}
